// import axios from "axios";
import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import api from "../Api/apicall";
import styles from "../component/custom.module.css";
import Images from "./Images";
import Modal from "react-modal";
import { Formik, Form, Field } from 'formik';

import * as Yup from 'yup';
import MultipleImageUpload from "./form/MultipleImageUpload";
import MultipleDocsUpload from "./form/MultipleDocsUpload";
import useScript from "../hooks/useScript";
import { CRITEO_EVENTS, CRITEO_SCRIPT_SRC, Criteo_trackEvent } from "../libs/criteo";
import SelectDropdown from "./form/SelectDropdown";


// import { useState } from "react";
export const isFilled = (val) => {
    return Boolean(val)
}
const miBirthDate = () => {
    let today = new Date()
    today.setYear(today.getFullYear() - 18)
    return today
}
const miBirthDateStr = new Intl.DateTimeFormat('en-CA', { dateStyle: 'short' }).format(miBirthDate())

const FormThankYouMsg = () => {
    return (
        <div className={'FormThankYouMsg'}>
            <h4 className={'mb-3'}>
                Form Submitted Successfully
            </h4>


        </div>
    )
}
const formInitialValues = {
    name: "",
    city_of_operations: "",
    birth_date: "",
    email: "",
    phone_number: "",
    business_name: "",
    incorporated_date: "",
    business_stage: "",
    business_service_years: "",
    last_year_business_turnover: '',
    educational_qualification_attachment_id: null,
    intro_video_attachment_id: null,
    photos: [],
    kyc_attachments: [],
    "office_address[address_line_1]": "",
    "office_address[address_line_2]": "",
    "residential_address[address_line_1]": "",
    "residential_address[address_line_2]": "",
    description: "",
}

const VIDEO_SUPPORTED_FORMATS = ['mp4', 'video/mp4', 'application/mp4']

const formValidationSchema = Yup.object().shape({
    name: Yup.string().min(2, 'Too Short!').max(200, 'Too Long!').required('Name is Required'),
    email: Yup.string().email().required('E-mail is Required'),
    city_of_operations: Yup.string().required('City of operations is required'),
    phone_number: Yup.string().min(10, 'Phone number must be 10 digits').max(15).required('Phone number Required'),
    birth_date: Yup.date().required('Birth date is required').max(miBirthDate(), 'Not eligible '),
    business_stage: Yup.string().required('This is required'),
    is_agreed: Yup.bool().oneOf([true], 'Please select the checkbox').required('Please check this to continue.'),
    //    intro_video_attachment_id: Yup.mixed().test(
    //        "fileFormat",
    //        "Unsupported file Format, use MP4 video file only",
    //        value => {
    //            if (!value) {
    //                return true
    //            }
    //            console.log(VIDEO_SUPPORTED_FORMATS.includes(value.type), value.type)
    //            return value && VIDEO_SUPPORTED_FORMATS.includes(value.type)
    //        }
    //    )
})

const businessStageOptions = [
    { label: 'Ideation Stage', value: 'Ideation Stage', },
    { label: 'Prototyping Stage', value: 'Prototyping Stage', },
    { label: 'In Operations', value: 'In Operations', },
]

function FormDetail({ myRef }) {
    const criteoScript = useScript(CRITEO_SCRIPT_SRC)
    const [openPreview, setOpenPreview] = useState(false)



    const [formResponse, setFormResponse] = useState(null)
    const [isTermsOpen, setisTermsOpen] = useState(false)

    const [modalIsOpen, setIsOpen] = useState(false);

    function showResponseModal() {
        setIsOpen(true);
    }

    function showResponseModalTerms() {
        setisTermsOpen(true);
    }

    function closeResponseModal() {
        setIsOpen(false);
    }

    function closeResponseModalTerms() {
        setisTermsOpen(false);
        console.log("=========")
    }

    // on page load call crite to track
    useEffect(() => {
        if (criteoScript === 'ready') {
            Criteo_trackEvent(CRITEO_EVENTS.VIEW_HOMEPAGE)
        }
    }, [criteoScript])


    // const formdata = new FormData();
    const photoupload = useRef(null);
    const documentupload = useRef(null);
    const videoupload = useRef(null);

    useEffect(() => {
        let tm = null
        if (formResponse) {
            tm = setTimeout(() => {
                setFormResponse(null)
                closeResponseModal();
                window.location.reload()
            }, 8000);
        }
        return () => {
            if (tm) {
                clearTimeout(tm)
            }
        }
    }, [formResponse])
    const handleFormSubmit = async (values, action) => {
        let payload = values
        if (values.photos?.length) {
            values.photos?.map((ph, phIndex) => {
                payload[`photos[${phIndex}]`] = ph
            })
        }
        if (values.kyc_attachments?.length) {
            values.kyc_attachments?.map((ph, phIndex) => {
                payload[`kyc_attachments[${phIndex}]`] = ph
            })
        }
        action.setSubmitting(true)
        await api("post", "api/forms/contact", payload, "psk").then(res => {

            setFormResponse(res)
            showResponseModal();
            Criteo_trackEvent(CRITEO_EVENTS.FORM_SUBMITTED, {
                id: (new Date),
                email: values.email,
                item: [
                    { id: "1", price: "1", quantity: "1" }
                ]
            })

        }, err => {
            if (err.response?.data?.errors) {
                action.setErrors(err.response?.data?.errors)
                // setFormResponse(err.response?.data)
            } else {
                // setFormResponse(err)
            }

        }).finally(() => {
            action.setSubmitting(false)
            // send pixel event
            //@ts-expect-error
            window.fbq('track', 'Lead');
        });

    }


    return (
        <Formik initialValues={formInitialValues} validationSchema={formValidationSchema}
            onSubmit={handleFormSubmit}>
            {({ values, handleChange, errors, handleSubmit, isSubmitting, setFieldValue }) => (
                <>
                    <section id="registerFrm" className={styles.FormDetailSection} ref={myRef}>

                        <div className="container">
                            <div className={styles.FormDetailTop}>
                                <img src={Images.DarkCom} />
                                <h2>
                                    Fill in your details and <br /> tell us more
                                </h2>
                            </div>
                            <div className={styles.FormDetailBottom}>

                                <form action="#">
                                    <div className={styles.wrapdivInner}>
                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="text"
                                                value={values.name}
                                                onChange={handleChange('name')}
                                                className={[values.name != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.name != "" && styles.selectedlable]}>
                                                name of the person
                                            </label>
                                            {errors.name && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.name}</p>
                                            )}
                                        </div>

                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="text"
                                                value={values.city_of_operations}
                                                onChange={handleChange('city_of_operations')}
                                                className={[values.city_of_operations != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.city_of_operations != "" && styles.selectedlable]}>city
                                                of
                                                operations</label>
                                            {errors.city_of_operations && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.city_of_operations}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.wrapdivInner}>
                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="date"
                                                value={values.birth_date}
                                                max={miBirthDateStr}
                                                onChange={handleChange('birth_date')}
                                                className={[values.birth_date != "" && styles.selectedinput]}
                                                style={{ color: values.birth_date == "" ? "transparent" : "gray" }} />
                                            <label htmlFor="yourname"
                                                className={[values.birth_date != "" && styles.selectedlable]}>date
                                                of birth</label>
                                            {errors.birth_date && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.birth_date}</p>
                                            )}
                                        </div>
                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="email"
                                                value={values.email}
                                                onChange={handleChange('email')}
                                                className={[values.email != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.email != "" && styles.selectedlable]}>E-mail</label>
                                            {errors.email && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.email}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.wrapdivInner + ' ' + styles.educational_field}>
                                        <div className={styles.wrapdivInnerMain + ' ' + styles.educational_field_left}>
                                            <input
                                                type="tel"
                                                value={values.phone_number}
                                                onChange={handleChange('phone_number')}
                                                className={[values.phone_number != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.phone_number != "" && styles.selectedlable]}>contact
                                                number</label>
                                            {errors.phone_number && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.phone_number}</p>
                                            )}
                                        </div>
                                        <div className={styles.wrapdivInnerMain}>

                                        </div>

                                    </div>

                                    <div className={styles.wrapdivInner}>
                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="text"
                                                value={values.business_name}
                                                onChange={handleChange('business_name')}
                                                className={[values.business_name != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.business_name != "" && styles.selectedlable]}>name
                                                of the
                                                business</label>
                                            {errors.business_name && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.business_name}</p>
                                            )}
                                        </div>
                                        <div className={styles.wrapdivInnerMain}>
                                            <input
                                                type="date"
                                                value={values.incorporated_date}
                                                onChange={handleChange('incorporated_date')}
                                                style={{ color: values.incorporated_date == "" ? "transparent" : "gray" }}
                                                className={[values.incorporated_date != "" && styles.selectedinput]} />
                                            <label htmlFor="yourname"
                                                className={[values.incorporated_date != "" && styles.selectedlable]}>Date
                                                of
                                                Incorporation</label>
                                            {errors.incorporated_date && (
                                                <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.incorporated_date}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className={styles.wrapdivInnerMainTop}>
                                        <span></span>
                                    </div>
                                    <div className={styles.wrapdivInnerMain}>
                                        <SelectDropdown
                                            name={'business_stage'}
                                            label={'What stage is your business currently in?'}
                                            options={businessStageOptions}
                                        />
                                    </div>
                                    <div className={styles.wrapdivInnerMain}>
                                        <SelectDropdown
                                            name={'business_service_years'}
                                            label={'How many years has the business been operational?'}
                                            options={[
                                                { label: 'Up to 1 Year', value: 'Up to 1 Year' },
                                                { label: '1-2 Years', value: '1-2 Years' },
                                                { label: '2-3 Years', value: '2-3 Years' },
                                                { label: '3+ Years', value: '3+ Years' },
                                                {
                                                    label: 'NA, Still in Ideation/ Prototyping Stage',
                                                    value: 'NA, Still in Ideation/ Prototyping Stage'
                                                }
                                            ]}
                                        />
                                    </div>
                                    <div className={styles.wrapdivInnerMain}>
                                        <input
                                            type="text"
                                            value={values.last_year_business_turnover}
                                            onChange={handleChange('last_year_business_turnover')}
                                            className={[values.last_year_business_turnover != "" && styles.selectedinput]}
                                        />
                                        <label htmlFor="yourname"
                                            className={[values.last_year_business_turnover != "" && styles.selectedlable]}>
                                            What was your Sales Turnover for FY 23-24 (optional)
                                        </label>
                                    </div>
                                    <div className={styles.wrapdivInnerMain}>
                                        <textarea
                                            rows="2"
                                            cols="2"
                                            value={values.description}
                                            onChange={handleChange('description')}
                                            className={[values.description != "" && styles.selectedinput]}></textarea>
                                        <label htmlFor="yourname"
                                            className={[values.description != "" && styles.selectedlable]}>Summary of your Business/ Idea
                                        </label>
                                        {errors.description && (
                                            <p className={'text-danger small mt-2 ' + styles.form_field_error}>{errors.description}</p>
                                        )}
                                    </div>
                                    <div className={styles.wrapdivInnerMainTop}>
                                        <span></span>
                                    </div>
                                </form>
                            </div>
                            <div className={`${styles.UploadFileInner} align-items-center`}>
                                <div
                                    className={styles.UploadFileRight}
                                    onClick={() => {
                                        videoupload.current.click();
                                    }}
                                //value={values.photos}
                                >
                                    <input
                                        ref={videoupload}
                                        type="file"
                                        id="file"
                                        style={{ display: "none" }}
                                        //accept="video/mp4,video/x-m4v,video/*"
                                        onChange={e => {
                                            setFieldValue('intro_video_attachment_id', e.target.files[0])
                                        }}
                                    />
                                    <span>Upload Your Video</span>
                                    <img src={Images.UploadFile} />
                                    <p>
                                        2 Minute Video Pitch of <br /> your business/ Idea
                                    </p>
                                    {values.intro_video_attachment_id ? (
                                        <p className="text-success mt-2">
                                            video file selected
                                        </p>
                                    ) : null}
                                    {errors.intro_video_attachment_id && (
                                        <p className={'text-danger small mt-2 ' + styles.form_field_error2}>{errors.intro_video_attachment_id}</p>
                                    )}
                                </div>
                                <div>
                                    <div>
                                        <p className={'small mb-3'}>
                                            Here is Sample Video to help you make your 2 minutes pitch.
                                        </p>
                                        <picture className={'d-block'} onClick={() => setOpenPreview({
                                            url: "https://www.youtube.com/embed/73CVgNWMvOw?&autoplay=1&rel=0",
                                        })}>
                                            <img src={require('../assets/images/promo_post_thumb_1.png')} className={'btn p-0 img--thumbnail cursor-pointer mb-3 '} />
                                        </picture>

                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <p className={'small mb-3'}>
                                            Here Is Video To Help You With The Registration Process.
                                        </p>
                                        <picture className={'d-block'} onClick={() => setOpenPreview({
                                            url: "https://www.youtube.com/embed/M8ebxoSTNbI?&autoplay=1&rel=0"
                                        })}>
                                            <img src={require('../assets/images/registration.png')} className={'btn p-0 img--thumbnail cursor-pointer mb-3 '} />
                                        </picture>
                                    </div>
                                </div>
                            </div>
                            <div>

                                <p className={'small text-left text-muted'}>
                                    * Company reserves the right to call for any additional information/
                                    documents, if required
                                </p>
                                <div className={styles.footer_section}>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="1" id="flexCheckDefault" defaultChecked={values.is_agreed} type="checkbox" onChange={(e) => {
                                            setFieldValue('is_agreed', e.target.checked)
                                        }} />
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            <a onClick={showResponseModalTerms} href="#" className={styles.TCspan}>terms and
                                                conditions </a>
                                        </label>
                                    </div>
                                    <p>Submit (Will be clickable only if T & C is accepted)</p>
                                    {errors.is_agreed && (
                                        <p className={'text-danger small mt-2 ' + styles.form_field_error2}>{errors.is_agreed}</p>
                                    )}
                                </div>
                                {1 && (
                                    <Modal
                                        style={{
                                            content: {
                                                display: "flex",
                                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                borderWidth: 0,
                                                flexDirection: "column",
                                                flex: 1,
                                                position: "unset",
                                                height: "100%",
                                                overflow: "auto",
                                                justifyContent: "center",
                                                zIndex: 9999999999999
                                            },
                                        }}
                                        // overlayClassName={Modalstyle.modal}
                                        isOpen={isTermsOpen}
                                        onRequestClose={closeResponseModalTerms}
                                        contentLabel="Example Modal"
                                    >
                                        <AgreementNotice closeResponseModalTerms={closeResponseModalTerms} />
                                    </Modal>
                                )}
                                {(errors && (errors).length) && (
                                    <div
                                        className="alert alert--has-icon alert-danger text-left mt-3 small d-flex w-100">
                                        <div className="alert__icon" style={{ width: '30px', marginRight: '1rem', }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                    d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                            </svg>

                                        </div>
                                        <div>
                                            <div className="mb-2">Please check all fields</div>
                                            <ol className="pl-3 mb-0">
                                                {Object.keys(errors)?.map(ek => (
                                                    <li key={`err_${ek}`}>
                                                        {errors[ek]}
                                                    </li>
                                                ))}
                                            </ol>
                                        </div>
                                    </div>
                                )}
                                <div className={styles.UploadFileInnerbtn}>
                                    <button
                                        type={'button'}
                                        className={[styles.commonBtnsecond, isSubmitting ? 'btn--submitting' : ''].join(' ')}
                                        onClick={handleSubmit}
                                        style={{ zIndex: 0 }}>
                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                        {isSubmitting ? <span className={'btn__loading'}></span> : null}

                                    </button>

                                </div>
                            </div>
                            <SampleVideo isOpen={Boolean(openPreview)} videoUrl={openPreview?.url} closeModal={() => setOpenPreview(false)} />
                            <Modal
                                style={{
                                    content: {
                                        display: "flex",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        borderWidth: 0,
                                        flexDirection: "column",
                                        flex: 1,
                                        position: "unset",
                                        height: "100%",
                                        overflow: "auto",
                                        justifyContent: "center",
                                    },
                                }}
                                // overlayClassName={Modalstyle.modal}
                                isOpen={modalIsOpen}
                                onRequestClose={closeResponseModal}
                                contentLabel="Example Modal"
                            >
                                <div className="container">
                                    <div className={styles.modalSubmit}>
                                        <img className={styles.modalClose} src={Images.Cancel}
                                            onClick={closeResponseModal} />
                                        <div style={{ textAlign: "center" }}>
                                            <img style={{ marginBottom: "15px" }} src={Images.SuccessChecked}
                                                onClick={closeResponseModal} />
                                            <FormThankYouMsg />
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </section>
                </>
            )}
        </Formik>
    );
}

const SampleVideo = ({ isOpen = false, closeModal, videoUrl }) => {
    return (
        <div>
            <Modal
                style={{
                    content: {
                        display: "flex",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderWidth: 0,
                        flexDirection: "column",
                        flex: 1,
                        position: "unset",
                        height: "100%",
                        overflow: "auto",
                        justifyContent: "center",
                    },
                }}
                // overlayClassName={Modalstyle.modal}
                isOpen={isOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div className="container">
                    <div className={styles.modalVideo}>
                        <img className={styles.modalClose} src={Images.Cancel} onClick={closeModal} />
                        {isOpen && (
                            <iframe width="100%" height="394" src={videoUrl} title="Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    )
}

const AgreementNotice = ({ closeResponseModalTerms }) => {
    return (
        <div className="container">
            <div className={styles.modalTandC}>
                <img className={styles.modalClose} src={Images.Cancel} onClick={closeResponseModalTerms} />
                <div className={styles.modalTandCInner}>
                    <h2>This event is arranged by Vedistry Private Limited, </h2>
                    <p>A part of Charak Pharma Private Limited (pioneers in the field of Ayurveda since 1947). </p>
                    <div className={styles.modalTandCInnerInfo}>
                        <span>Eligibility Criteria: </span>
                        <p>1. This is applicable only for Women Entrepreneurs who are Indian Nationals. </p>
                        <p>2. The minimum age of entry is 18 years and the participant should be of sound health and
                            mind. </p>
                        <p>3. The Participant should atleast have a working prototype or proof of concept at the time of
                            application to be eligible. </p>
                        <p>4. The Participant shall share her personal details along with the required identity proof
                            viz. Aadhaar & PAN</p>
                        <p>5. The participant shall submit the details of her start-up / business in brief alongwith the
                            supporting documents viz. PAN card, Aadhaar Card, Incorporation Certificate/ Partnership as
                            main working partner/ Managing Director/ Proprietorship/ Private Ltd. Co., details etc. </p>
                        <p>6. The participant shall submit her ITR return/business ITR whichever is applicable of the
                            last two years as a proof for her business. </p>
                        <p>7. One person can participate with one single business /business idea only. Multiple business
                            / business ideas cannot be pitched by one participant. </p>
                        <span>GENERAL TERMS & CONDITIONS: </span>
                        <p>1. Participation in this event by sending an entry in the aforesaid manner shall be
                            considered to be acceptance of these Terms and Conditions. </p>
                        <p>2. There is no levy of an entry fee for participating in the event. Any person who claims to
                            be from the Company and asks the Participant for paying an entry fee for participating in
                            the event is defrauding them and they should report this to the local police
                            immediately. </p>
                        <p>3. Participant must enter the event on her own behalf only and Entry by proxy will not be
                            accepted, even by family members. </p>
                        <p>4. The Entry is not transferrable. </p>
                        <p>5. The Participant shall undertake, warrant and guarantee to the Company, that the
                            Participant has the full legal capacity to participate in the event in accordance with these
                            Terms and Conditions. </p>
                        <p>6. The Participant hereby represents that she or her business has never filed for bankruptcy
                            or faced any legal hassles in the past. </p>
                        <p>7. The Participant represents that she has not been accused or convicted or is otherwise
                            involved in any criminal offence and/or is not under inquiry or trial by the police or
                            judiciary. </p>
                        <p>8. The Company also reserves the right to disqualify a Participant, in case of any
                            third-party claims received by the Company, pertaining to such Participant’s submitted
                            product/idea/invention/business.
                            The Company shall not be responsible for any infringement done by the Participant of any
                            third party’s Intellectual Property rights. The Participant hereby agrees that any such
                            claims shall be settled by the Participant directly with such third-parties making the
                            claims and shall indemnify the Company from any and all such claims, at all times. </p>
                        <p>9. The Participant hereby represents that she is not under any exclusive contract with any
                            other third party/agency/production house either individually and/or with respect to the
                            product/business proposal being pitched or submitted with the Company and/or is not under
                            any kind of disqualification under law, as the case may be. The Company reserves the right
                            to disqualify any Participant who is under any such exclusive contract or other
                            disqualifications. </p>
                        <p>10. The Participant will be required to furnish necessary documents supporting the business
                            pitch/plan, such material will be considered as “Submitted Material” that is owned by the
                            Participant. The Participant confirms that such Submitted Material is (i) being submitted
                            voluntarily by the Participant for her selection in the event; (ii) it is original and is
                            not based on any other material or source; (iii) the acceptance, storage, use and
                            exploitation thereof will not violate or infringe any third party rights and (iv) The
                            Participant has the right/authority to submit and to offer such material to the Company
                            without obligation to any third party, and the consent of no other person or entity is
                            required. </p>
                        <p>11. The Participant understands that the Submitted Material will be reviewed by the Company
                            and any third-party agencies as may be hired by the Company with respect to the event. For
                            the purpose of the same, the Participant hereby expressly consents to the Company reviewing
                            the Submitted Materials and sharing the same with third-party agencies, strictly for the
                            purpose of the event. </p>
                        <p>12. The Participant understands that the Company might receive similar business proposals
                            from different individuals and it shall be the Company’s sole discretion to decide which
                            Submitted Materials or Participant to choose. </p>
                        <p>13. The Company has the right at any time to require additional proof of identity and/or
                            eligibility. Failure to provide such proof within a reasonable time could result in
                            disqualification from the event. </p>
                        <p>14. The Company is in no manner whatsoever responsible and/or shall not be held liable in any
                            manner whatsoever, for any physical injury, death, mental trauma caused to any Participant
                            in any manner whatsoever. </p>
                        <p>15. If the Participant is shortlisted, she will have to attend an in person interview that
                            shall be held in Mumbai. The Company shall not be responsible for making arrangements or
                            paying for the travel, lodging and food expenses of the Participant and for any of their
                            companions for the purpose of attending the interview. </p>
                        <p>16. The Participant of the event agrees that she shall indemnify and shall hold harmless the
                            Company, its affiliates, employees, officers, sub-contractors, Judges or any other person in
                            connection with the event, against any third party claims of whatsoever nature including but
                            not limited to (i) any claims of infringement of any third party rights (ii) any leak or
                            disclosure of their idea/product/invention/service or business information (iii) any
                            misrepresentation, misconduct, fraud by the Participant (iv) any breach of law (v) any acts
                            or omissions with respect to the event (vi) any breach of the Terms and Conditions
                            hereunder. </p>
                        <p>17. The disbursement timeline of the fund of Rs. 15,00,000/- (Rupees fifteen Lakhs only),
                            Rs. 500,000/-(Rupees Five Lakhs only) & Rs. 200,000/- (Rupees Two Lakhs only) to the
                            shortlisted winner, 1st runner up and 2nd runner up participants respectively ,shall solely
                            reside with the Company. The Company will not hold any equity or debt of any sort in the business
                            of the Participant for the funds granted. Denial to disburse the above mentioned fund of
                            Rs. 15,00,000/- (Rupees fifteen Lakhs only), Rs. 500,000/- (Rupees Five Lakhs only) & Rs. 200,000/- (Rupees Two Lakhs only)
                            to the shortlisted winner, 1st runner up and 2nd runner up  Participants due to non-compliance,
                            errors in the business plan and documentation is at the Company’s sole discretion. </p>
                        <p>18. The company shall not be responsible for the way in which the shortlisted participant
                            utilizes the funds received herein. </p>
                        <p>19. The shortlisting of the candidate/final candidate shall be the sole discretion of the
                            Company and the Company shall not be liable to disclose the same to anyone. The decision of
                            the Company shall be final and binding and shall not be challenged before any court of
                            law. </p>
                        <p>20. The Company reserves the right to amend (add, delete or modify) the Terms and Conditions
                            governing the event and/or the Participant selection process prospectively or
                            retrospectively, at its discretion and without prior notice, in order to improve the event
                            or remedy any issues that occur. Withdrawal of this event is at the Company’s sole
                            discretion. </p>
                        <p>21. Any dispute arising out of this event shall be subject to the jurisdiction of the courts
                            of Mumbai and the laws of India. </p>
                        <p>22. The Company reserves the right to change the terms and conditions of this event,
                            including extending, withdrawing or discontinuing the same without notice or without
                            assigning any reason, at its sole discretion without any liability. </p>
                        <p>23. The participant is aware and agrees that the information shared by the participants
                            including their videos of pitching ideas shall be used by the Company as promotional
                            material anytime during and after the event. </p>
                    </div>
                    {/* <button type="button" onClick={closeResponseModalTerms}>Confirm</button> */}
                </div>
            </div>
        </div>
    )
}

export default FormDetail;
